import { render, staticRenderFns } from "./VideoUploadDialog.vue?vue&type=template&id=6106dfaa&scoped=true&"
import script from "./VideoUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./VideoUploadDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VideoUploadDialog.vue?vue&type=style&index=0&id=6106dfaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106dfaa",
  null
  
)

export default component.exports